import Modal from 'react-modal';
import { Content, Header } from './style';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  isOpen: boolean;
  onRequestClose: () => void;
}

export default function ModalFeedbackForm({ isOpen, onRequestClose }: Props) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-feedback-form-content">
      <Header>
        <div className="close-div">
          <button type="button" onClick={onRequestClose}>
            <CloseIcon fontSize="small" />
          </button>
        </div>
      </Header>
      <Content>
        <iframe
          title="Microsoft Form"
          src="https://forms.office.com/pages/responsepage.aspx?id=-4lZA0zAQkGqUQAKXNFEiQW5U-P-TOtLgJ2oTiLQpAJUREZETjU2Qk8yMUpGOU00WEpFUlNPVDBPTy4u&route=shorturl"
          allowFullScreen
          loading="lazy"
        />
      </Content>
    </Modal>
  );
}
